import { useSyncExternalStore } from 'react';

const QUERY = '(max-width: 1023px)';

const subscribe = (callback) => {
  if (typeof window === 'undefined') return () => {};
  const mql = window.matchMedia(QUERY);
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
};

const getSnapshot = () =>
  typeof window === 'undefined' ? false : window.matchMedia(QUERY).matches;

const getServerSnapshot = () => false;

export const useIsMobile = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
